/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Emitted by tools/generate-api-client.mjs (generator 1.0.0) from the
 * pinned OpenAPI document src/api/spec/openapi.json, spec version 0.130.0.
 *
 * 12-development-plan §2.4 control 2: the client is generated from a named spec version,
 * committed, and bumped by an explicit pull request. `npm run api:check` fails the build
 * when this file no longer reproduces from the pinned spec, so a hand edit here is not a
 * shortcut — it is a build failure with your name on it.
 */

/** The named spec version this client is pinned to — `info.version` of the document. */
export const SPEC_VERSION = "0.130.0";

/** `info.title` of the pinned document. */
export const SPEC_TITLE = "Bata retail planning platform";

/** OpenAPI dialect of the pinned document. */
export const OPENAPI_VERSION = "3.1.0";

/** SHA-256 of the pinned document's bytes. The drift gate compares this. */
export const SPEC_SHA256 = "ff8a99a453b640cf6e97804f4ddd8a52468d594155311c67eef7877562f86daf";

/** Version of the emitter that produced this client. */
export const GENERATOR_VERSION = "1.0.0";

/** Operations exposed by the pinned document. */
export const OPERATION_COUNT = 492;

/** Component schemas exposed by the pinned document. */
export const SCHEMA_COUNT = 1085;
